function initTeamsPage(){
    
  let formLinks = document.querySelectorAll('a[href="#try-popl-teams"]');
  let joinWaitListLinks = document.querySelectorAll('a[href="#join-the-waitlist"]')
  let partnerLinks = document.querySelectorAll('a[href="#partner"]')
   let attendeeListLinks = document.querySelectorAll('a[href="#attendee-list"]')
   let exhibitorListLinks = document.querySelectorAll('a[href="#exhibitor-list"]')
  let startFreeFormLinks = document.querySelectorAll('a[href="#try-popl-teams-free"]');
  let singleInputContainer = document.getElementById('leadform1');
  let teamsModalHeader = document.getElementById('teamsModalHeader');
  let teamsModalSubtext = document.getElementById('teamsModalSubtext');
  let originalTeamsScrollPosition;
  let mobileLogo = document.querySelector('a.header__logo:not(.no-modal)');
  let modal = document.getElementById('teamsModal');

  let closeButton = document.getElementById('modalClose');

  let body = document.getElementById('poplBody');
  let dynamicLink = document.getElementById('dynamicLink');
  let navLinks = document.querySelectorAll('.header__link-list:not(.no-modal) ul li a:not(.no-modal)');
  // let summaryLinks = document.querySelectorAll('.header__link-list ul li summary');
  // let loginLink = document.querySelector('a.popl-header-login');
  let mobileNav = document.querySelector('.header__icon-list button.tap-area');

 
  // let dropdownLinks = document.querySelectorAll('.dropdown-menu .dropdown-menu__item');
 
  Array.from(formLinks).forEach(link=>{
    link.addEventListener('click', (e)=>{
      e.preventDefault();
      // teamsModalHeader.textContent='See Popl in action';
      // teamsModalSubtext.textContent='Schedule a 25 minute live product demo with full Q&A'
  //   singleInputContainer.scrollIntoView({ behavior: "smooth",block: 'center',
  //   inline: 'center'});
  originalTeamsScrollPosition = window.scrollY;
  modal.show();
    modal.style.height = `100vh`; 
modal.style.top = `${originalTeamsScrollPosition}px`; 
    });
  });
 
 
  Array.from(joinWaitListLinks).forEach(link=>{
    link.addEventListener('click', (e)=>{
      e.preventDefault();
      teamsModalHeader.textContent='Join the waitlist';
      teamsModalSubtext.textContent="Submit the form and we'll be in touch"
  //   singleInputContainer.scrollIntoView({ behavior: "smooth",block: 'center',
  //   inline: 'center'});
        originalTeamsScrollPosition = window.scrollY;
        modal.show();
          modal.style.height = `100vh`; 
      modal.style.top = `${originalTeamsScrollPosition}px`; 
    });
   
  });
    Array.from(partnerLinks).forEach(link=>{
    link.addEventListener('click', (e)=>{
      e.preventDefault();
      teamsModalHeader.textContent='Become a Solutions Partner';
      teamsModalSubtext.textContent="Submit the form and we'll be in touch"
  //   singleInputContainer.scrollIntoView({ behavior: "smooth",block: 'center',
  //   inline: 'center'});
        originalTeamsScrollPosition = window.scrollY;
        modal.show();
          modal.style.height = `100vh`; 
      modal.style.top = `${originalTeamsScrollPosition}px`; 
    });
   
  });
  Array.from(attendeeListLinks).forEach(link=>{
    link.addEventListener('click', (e)=>{
      e.preventDefault();
      teamsModalHeader.textContent='Book a meeting to get the list';
      teamsModalSubtext.textContent="Schedule a 25 minute live product demo to see how Popl helps GTM teams turn conferences into their #1 growth channel."
  //   singleInputContainer.scrollIntoView({ behavior: "smooth",block: 'center',
  //   inline: 'center'});
        originalTeamsScrollPosition = window.scrollY;
        modal.show();
          modal.style.height = `100vh`; 
      modal.style.top = `${originalTeamsScrollPosition}px`; 
    });
   
  });
  if(exhibitorListLinks){
      Array.from(exhibitorListLinks).forEach(link=>{
    link.addEventListener('click', (e)=>{
      e.preventDefault();
      teamsModalHeader.textContent='Book a meeting to get the list';
      teamsModalSubtext.textContent="Schedule a 25 minute live product demo to see how Popl helps GTM teams turn conferences into their #1 growth channel."
  //   singleInputContainer.scrollIntoView({ behavior: "smooth",block: 'center',
  //   inline: 'center'});
        originalTeamsScrollPosition = window.scrollY;
        modal.show();
          modal.style.height = `100vh`; 
      modal.style.top = `${originalTeamsScrollPosition}px`; 
    });
   
  });
  }
  Array.from(startFreeFormLinks).forEach(link=>{
      link.addEventListener('click', (e)=>{
        e.preventDefault();
        teamsModalHeader.textContent='Let’s get started';
        teamsModalSubtext.textContent='Submit the form below as a next step'
    //   singleInputContainer.scrollIntoView({ behavior: "smooth",block: 'center',
    //   inline: 'center'});
    originalTeamsScrollPosition = window.scrollY;
    modal.show();
      modal.style.height = `100vh`; 
  modal.style.top = `${originalTeamsScrollPosition}px`; 
      });
     
    });

  modal.addEventListener('dialog:after-show', (e)=>{
      // hbspt.forms.create({
      //     region: "na1",
      //     portalId: "19933619",
      //     formId: "c29afcbe-2918-465a-9786-904c81979234",
      //      target: ".modal-form-container"
      //   });

    originalTeamsScrollPosition = parseInt(modal.style.top);
      document.body.style.overflow='hidden'; 
      sessionStorage.setItem("viewedModal", "true");

   
  });
  modal.addEventListener('dialog:after-hide', (e)=>{

      dynamicLink.style.display='none';
    document.body.style.overflowX='hidden';
    document.body.style.overflowY='scroll';
    if(originalTeamsScrollPosition){
    window.scrollTo(0,originalTeamsScrollPosition);
  }

});
 
function preventDefault(e) {
  e.preventDefault();
}

if ( sessionStorage.getItem("viewedModal") == null){
  sessionStorage.setItem("viewedModal", "false");
}
closeButton.addEventListener('click', (e)=>{
      modal.hide();

});


// mobileNav.addEventListener('click', (e)=>{
// e.preventDefault();
// if ( sessionStorage.getItem("viewedModal") == 'false'){
//    showModal('Go To Homepage','https://popl.co' )
   
// }


// });
// if (mobileLogo){
// mobileLogo.addEventListener('click', (e)=>{
//     e.preventDefault();
//     if ( sessionStorage.getItem("viewedModal") == 'false'){
//        showModal('Go To Homepage','https://popl.co' )
//     }
//     else{
//     window.location.href = mobileLogo.href
//     }

// });
// }




// Array.from(summaryLinks).forEach(link =>{
//   link.setAttribute('teamsPage', 'true');
// });
// Array.from(navLinks).forEach(link =>{
//   link.setAttribute('teamsPage', 'true');
//   link.addEventListener('click', (e)=>{
//     e.preventDefault();
//     e.stopImmediatePropagation();
//     if ( sessionStorage.getItem("viewedModal") == 'false'){
       
//         let linkText = '';
//         if (link.innerText.includes('Enterprise')){
//           linkText='Go To Enterprise';
//         }else if(link.innerText.includes('Digital Business Cards')){
//                   linkText='Go to Digital Business Cards';
//         }else if(link.innerText.includes('Badge Scanner')){
//                   linkText='Go to Universal Badge Scanner';
//         }else if(link.innerText.includes('Event Lead Capture')){
//                   linkText='Go to Event Lead Capture';
//         }else{
//                   linkText = 'Go to ' + link.innerText;
//         }
    
//       showModal(linkText,link );
      
//   }
//   else{
//     window.location.href = link.href
//     }
//   }); 
  
// });

// Array.from(dropdownLinks).forEach(link =>{
//   link.setAttribute('teamsPage', 'true');
//   link.addEventListener('click', (e)=>{
//     e.preventDefault();

//     if ( sessionStorage.getItem("viewedModal") == 'false'){
//       showModal(`Go to ${link.innerText}`,link )    
//   }
//   else{
//     window.location.href = link.href
//     }
//   });
  
// });
const showModal = (text, link) => {
  dynamicLink.textContent =text;
  dynamicLink.href=link;
  dynamicLink.style.display='flex';
  originalTeamsScrollPosition = window.scrollY;
  modal.show();
    modal.style.height = `100vh`; 
modal.style.top = `${originalTeamsScrollPosition}px`; 

};
const hideModal = () => {

  dynamicLink.style.display='none';
  modal.hide();

};
const listenForClick = () => {
  body.addEventListener('click', (e)=>{
    if(e.target === modal){
      hideModal();
    }
  })
};
 
}

addLoadEvent(initTeamsPage);



